import React, { useState, useEffect, useCallback, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import {useDecode} from "../hooks/useDecode"
import 'rc-slider/assets/index.css'
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { addFabricToCart } from "../redux/reducers/fabric/actions"
import { setSpinner } from "../redux/actions/spinner"
import { log } from "../utilities/logger"
import { RepeatPanel } from "./RepeatPanel"
import { FabricDimensions } from "./FabricDimensions"
import { TileSize } from "./PatternSize"
import { FabricTypes } from "./FabricTypes/FabricTypes"
import alertify from '../libs/alert'
import { ACTIONS, openImageLibraries, setScreenType } from "../ImageLibrary/redux/actions"
import { UploadButton } from "../editor/UploadButton"
import { switchFabricSelectorVisibility } from "../FabricLibrary/redux/actions"
import { OrderOptions } from "./OrderOptions/OrderOptions"
import { setProduct, setProductId } from "../redux/actions/product"
import { OrderQuantity } from "./OrderQuantity"
import { ThirdPartyLibraryState } from "../ImageLibrary/types/ThirdPartyLibrary"

export type ControlPanelProps = {
  fabricWidth: number
  fabricLength: number
  activePart: any
  fabricMaxLength: number
  stepSize:number
  partId:string
  scenDimensions:{width:number, height:number},
  displayPatternSelector?: (libs:string[])=>void
}

export type OptionType = {
  isPrimary: boolean,
  name: string,
  quantity: number
}

export const ControlPanel = (props:ControlPanelProps) => {

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const parts = useSelector((state:any) => state.parts)
  const product = useSelector((state:any) => state.product)
  const products = useSelector((state: any) => state.products);
  const [data, setData] = useState({length: 0, price: 0, basePrice: 0})
  const [size, setSize] = useState({width: 0, height: 0})
  const settings = useSelector((state:any) => state.settings)||{}
  const part = useMemo(() => { return parts.find((part: any) => part.active) }, [parts])

  const currency = useDecode(
    product && product.currency ? product.currency : "",
  )

  const isPatternDesign = useSelector((state:any) => state.uploadedImgSource);

  const images = useSelector((state: any) => state.canvasImages && state.canvasImages.images)

  const sample1 = product?.sample1 !== undefined ? currency + product.sample1 : undefined;

  const sample2 = product?.sample2 !== undefined ? currency + product.sample2 : undefined;

  const useFabricListParam = useSelector((state: any) => state.fbdata?.useFabricList);
  const useFabricList = useFabricListParam ? useFabricListParam : 'dropdown'

  const imageLibraries = useSelector((state: any) => state.fbdata?.useThirdPartyImageLibrary);

  const hideRepeatPanel = useSelector((state: any) => state.fbdata?.hideRepeatPanel);

  const fabricSizeUnit = useSelector((state:any) => state.settings.unitType)

  const [selectedOption, setSelectedOption] = useState(undefined as undefined | OptionType);

  const sendToHost = useCallback((action) => {
    let url =
        window.location !== window.parent.location
            ? document.referrer
            : document.location.origin

    window.parent.postMessage(
        JSON.stringify({
            action
        }),
        url,
    )
  }, [window])

  useEffect(() => {
    if (settings.display && settings.configuration) {
      let { display:{currentLength}, configuration } = settings

      //const price = currentLength * ((product?.price || 0)/(configuration?.stepSize||1));
      //const price = currentLength * (product?.price || 0);
      let price = currentLength * (product?.price || 0);
      //Checking if the product has price bands
      if (product.optionName!=null && product.optionName!="")
      {
        let theOptions = product.orderOptions;
        var filteredObj = theOptions.find(function(item:any, i:any){
          if(item.name === product.optionName){
            if (item.height) price = product?.price || 0;
            if (item.priceTable)
            {
              let theBands = item.priceTable.bands;
              if (theBands!=null)
              {
                const BreakError = {};
                try {
                  theBands.forEach(function (value:any){
                    var min = +value.min;
                    if (value.max=='')
                    {
                      var max = 10000;
                    }
                    else
                    {
                      var max = +value.max;
                    }
                    
  
                    if (currentLength>=min && currentLength<=max)
                    {
                      var theDiscount = +value.discount;

                      price = currentLength*(product?.adjustedPrice*((100-theDiscount)/100));
                      
                      throw BreakError;  
                    }
  
                  });                  
                } catch (error) {
                  if (error !== BreakError) throw error;
                }
              }
            }
          }
        });

      }

      setData({ length: currentLength, price: price, basePrice: product?.basePrice })
    
      if(product?.isPrimary){
        setSelectedOption({
          isPrimary: true,
          name: product.optionName,
          quantity:1
        })
      }
    }
  }, [settings, product])

  const openSidebarHandler = () => {
    if (window.parent) {
      sendToHost('SCROLL_TO_TOP');
    }

    dispatch(setScreenType("EditorScreen"))
    dispatch(switchFabricSelectorVisibility(true, selectedOption,0))
  }

  const addToCart = useCallback(
    e => {
      e.preventDefault()
      dispatch(addFabricToCart(() => {
        dispatch(setSpinner(true))
      
      }, (opt, error) => {
        dispatch(setSpinner(false))
        if(opt){
        addToCartHandler(opt)
        }else{
          error && alertify.alert('Error',error.message,'')
  }
      }, e.target.id))
    },
    [dispatch, parts, product],
  )

  const addToCartHandler = (opt:any) => {
    const url = window.location !== window.parent.location
                  ? document.referrer
                  : document.location.origin

    console.groupCollapsed("ADD_TO_CART")
    log(JSON.stringify(opt))
    console.groupEnd()

    if (!opt.content) {
      console.error("Can't save the data")
    } else {
      window.parent.postMessage(JSON.stringify(opt), url)
    }
  }

  const [isTyping,setIsTyping] = useState(false);

  return (
    <div className={"page"}>
      <div className={"toolPanel"}>
        <div className={"toolBar"}>
          <div className="pick-pattern-button"
               title="Pick Image from Library"
                onClick={()=>{
                  if (window.parent) {
                    sendToHost('SCROLL_TO_TOP');
                  }
                  dispatch(setScreenType('EditorScreen'))
                  dispatch(openImageLibraries())
                }}>
            <button className="pickAPattern" />
            {t("editor.custom.tile-library")}
          </div>
          <UploadButton fabricSize={props.scenDimensions} partId={props.partId} />
        </div>
        <div className={"titleHeader"}>
          <div className={"patternName"}
              title={images && images.length && images[0].name?.substring(0, images[0].name?.lastIndexOf('.')) || part?.content_images[0]?.file?.name?.substring(0, part?.content_images[0]?.file?.name?.lastIndexOf('.')) || ""}>
                {images && images.length && images[0].name?.substring(0, images[0].name?.lastIndexOf('.')) || part?.content_images[0]?.file?.name?.substring(0, part?.content_images[0]?.file?.name?.lastIndexOf('.')) || t("editor.custom.toolPanel_patternName")}
          </div>
        </div>
        <div className={"hr"}/>
        <div className={"sizeParent"}>
          <TileSize part={part} />
          <div className={"advisoryLabel"}>
            {t("editor.custom.toolPanel_size_disclaimer")}
          </div>
          <div className={"hr"}/>
        </div>
        {(!isPatternDesign || !hideRepeatPanel)?
        <div className={"repeatParent"}>
          <RepeatPanel partId={part?._id} isPatternDesign={isPatternDesign} />
          <div className={"hr"}/>
        </div>:null}
        
        <div className={"fabricParent"}>
          <div className={(useFabricList === 'dropdown' ? "fabricTypeDropdown" : "fabricType")}>
            <div className={"fabricLabel " + (useFabricList === 'dropdown' ? "fabricLabel_dropdown" : "")}>{t("editor.custom.toolPanel_fabricType_label")}</div>
            {useFabricList === 'dropdown'?<div>
              <FabricTypes selFabricOption={selectedOption}/>
            </div>
            :
            <div className={"fabricEdit"} onClick={openSidebarHandler}>
              <div className={"fabricEditDiv"}>
                {t("editor.custom.toolPanel_changeFabric_btn")}
              </div>
            </div>}
          </div>
          <div className="fabricName">
            <div>{product?.name}</div>
            {product?.price ? <div>
              <div>{product && product.currency ? currency : ""}{" "}{`${(product?.basePrice||product?.price).toFixed(2)}`}</div>
            </div> : null}
          </div>

          <div className={"hr"}/>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {((product?.orderOptions?.length || 0) > 1) ? 
                <div className="orderOptionsDiv">
                  <div className="orderOptionsLabel">{t("editor.custom.toolPanel_orderLabel")}</div>
                  <div className="orderOptionsDrodownDiv">
                      <OrderOptions placeholder="" 
                        value={product?.optionName} 
                        list={product?.orderOptions}
                        onSelectionCancelled={() => {
                          dispatch(setProduct({...updateProduct(product)}))
                        }}
                        onValueSelected={(selectedOrderOption, index) => {
                          const { width, productID, totalLength, name, price, height } = selectedOrderOption
                      const isPrimary = !!totalLength
                      // const isPrimary = !!height
                      const updatedOrderQuantity = (isPrimary ? 1 : selectedOption?.quantity) || 1;
                      
                      setSelectedOption({
                        isPrimary,
                        name,
                        quantity: updatedOrderQuantity
                      })
                      dispatch(setProduct({
                        ...product, width, productID, totalLength: totalLength||height,
                        price: updatedOrderQuantity * price,
                        basePrice: price,
                        optionName: name,
                        isPrimary,
                      }));
                    }} />
                  </div>
                </div> 
            : null}
          <div className={"fabricInfo"}>
              {(!selectedOption || selectedOption?.isPrimary) ?
                <FabricDimensions
                  setTypingInProgress={setIsTyping}
                  stepSize={props.stepSize}
                  activePart={props.activePart} 
                  maxLength={props.fabricMaxLength} 
                  fabricWidth={props.fabricWidth} 
                  currentPartLength={props.fabricLength} />
              :<OrderQuantity stepSize={1} 
                  setTypingInProgress={setIsTyping}
                  maxLength={props.fabricMaxLength} 
                  currentPartLength={selectedOption?.quantity}
                  onOrderChanged={(value)=>{
                    setSelectedOption({
                      ...selectedOption,
                      quantity: value
                    })
                    dispatch(setProduct({
                      ...product,
                      orderQuantity: value,
                      price: product?.basePrice * value,
                  }));
                  }} />}
            <div className={"fabricPrice"}>
              <div className={"priceLabel"}>{t("editor.custom.toolPanel_fabricPrice")}</div>
              <div className={"priceValue"}>{product && product.currency ? currency : ""}{" "}{product && product.price ? data.price.toFixed(2) : ""}</div>
              <div className={"priceInfo"}>{t("editor.custom.toolPanel_fabric_seemyprice_link")}</div>
            </div>
          </div>
          </div>

          <div className={"hr"}/>
        </div>

        <div className={"optionsParent"}>
          <div className={"addToCartDiv"}>
            <button style={{opacity:isTyping?0.5:1, cursor:isTyping?'not-allowed':'pointer'}} disabled={isTyping} id="0" className={"addToCartBtn"}
                    onClick={addToCart}
                    >{t("editor.custom.toolPanel_addtocart")}</button>
          </div>
          {/*sample1?<div className={"addToCartSamplesDiv"}>
            <button id="1" className={"addToCartSamplesBtn"}
                    onClick={addToCart}
                    >{t("editor.custom.toolPanel_addtocart1")} {sample1?sample1:"Sample 1"}</button>
            </div>:null*/}
          {((product?.orderOptions?.length||0) <= 1) && sample2 ? <div className={"addToCartSamplesDiv"}>
            <button id="2" className={"addToCartSamplesBtn"}
                    onClick={addToCart}
                    >{t("editor.custom.toolPanel_addtocart2")} {sample2?sample2:"Sample 2"}</button>
          </div>:null}
        </div>
      </div>
    </div>
  )
  
}

const updateProduct = (product: any, orderOption?:OptionType) => {
  let index = (product.orderOptions || []).findIndex((option: any) => option.name === orderOption?.name)
  index = index + 1 ? index : 0
  const optionToSelect = product.orderOptions?.length && product.orderOptions[index]
  const isPrimary=!optionToSelect || !!optionToSelect.totalLength
  const optionQty = (!optionToSelect || optionToSelect.totalLength ? 1: orderOption?.quantity)||1
  return {
  ...product,
      isPrimary,
  ...product.orderOptions?.length && {
          productID: product.orderOptions[index].productID,
          width: product.orderOptions[index].width,
          totalLength: product.orderOptions[index].totalLength || product.orderOptions[index].height,
          price: product.orderOptions[index].price * optionQty,
          basePrice: product.orderOptions[index].price,
          optionName: product.orderOptions[index].name,
          
      }
  }
  }

